// export default [
//   10,
//   15,
//   25,
//   35
// ]
const icon4 = require('@/assets/cursor-icons/icon4.svg')
const icon10 = require('@/assets/cursor-icons/icon10.svg')
const icon20 = require('@/assets/cursor-icons/icon20.svg')
const icon30 = require('@/assets/cursor-icons/icon30.svg')
const icon40 = require('@/assets/cursor-icons/icon40.svg')

export default [
  { size: 4, cursor: icon4 },
  { size: 10, cursor: icon10 },
  { size: 20, cursor: icon20 },
  { size: 30, cursor: icon30 },
  { size: 40, cursor: icon40 }
]